import { b2x } from '@b2x/react/src';

import { NewsletterContentType } from '../contentTypes';
import { NewsletterForm } from '../forms/NewsletterForm';

interface PopUpNewsletterModalProps {}

export const PopUpNewsletterModal = (props: PopUpNewsletterModalProps) => {
  const content = b2x.useContent<NewsletterContentType>('NEWSLETTER_CONTENT');
  return (
    <>
      <div className="text-center mb-3">
        <h5 className="fw-semi-bold text-blue">{b2x.formatHtml(content?.body.title)}</h5>
        <span>{b2x.formatHtml(content?.body.subTitle)}</span>
      </div>
      <NewsletterForm className="newsletter-modal-popup" emailFieldStyle="textInput" source="website-modal" />
    </>
  );
};
